import { ICollaboratorSchema } from "@wingspanhq/payments/dist/interfaces";
import { IDeductionResponse } from "@wingspanhq/payments/dist/interfaces/api/deductions";
import { PayeeRow } from "@wingspanhq/wingspan-api-sdk";
import isEmpty from "lodash/isEmpty";
import { cleanCSVData } from "../../../shared/utils/csv";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";

export type DeductionTableItem = {
  deduction: IDeductionResponse;
  collaborator?: ICollaboratorSchema;
  payeeRow?: PayeeRow;
};
const mapDeductionTableItemData = (tableItem: DeductionTableItem) => {
  const { deduction, payeeRow } = tableItem;

  if (!deduction) {
    return {};
  }

  const payeeRowCompanyName =
    payeeRow?.profile?.companyName || payeeRow?.profile?.doingBusinessAs;

  return {
    "Created Date": deduction.createdAt,
    "Start Date": deduction.startDate,
    "External Contractor ID": payeeRow?.externalId,
    "Contractor Name": payeeRow ? selectorSearchRowName(payeeRow) : undefined,
    "Contractor First Name": payeeRow?.profile?.firstName,
    "Contractor Last Name": payeeRow?.profile?.lastName,
    // The preferred name is not materialized on the v3 search row.
    "Contractor Preferred Name": undefined,
    "Contractor Company Name": payeeRowCompanyName,
    "Contractor Email": payeeRow?.email,
    "Deduction Status": deduction.status,
    "Deduction Type": deduction.type,
    "Deducted Payable IDs": deduction.application
      .map(a => a.payableId)
      .join(", "),
    "Deduction ID": deduction.deductionId,
    "Deduction Details": deduction.detail,
    "Deduction Template ID": deduction.deductionTemplateId,
    Amount: deduction.amount,
    "Amount Deducted": deduction.application
      .map(a => a.amountDeducted)
      .reduce((a, b) => a + b, 0),
    Currency: deduction.currency,
    Priority: deduction.priority,
    "Deduction Name": deduction.name
  };
};
export const mapDeductionsTableToCSV = (data: Array<DeductionTableItem>) => {
  let cleanResult = [];

  const dirtyResult = data
    .map(d => {
      try {
        return mapDeductionTableItemData(d);
      } catch (error) {
        console.error(error);
      }
      return {};
    })
    .filter(d => !isEmpty(d));

  cleanResult = dirtyResult.map(d =>
    cleanCSVData(d, dirtyResult)
  ) as Array<any>;

  return cleanResult;
};
